import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, CssBaseline } from '@mui/material';

// Brand fonts (self-hosted via @fontsource).
import '@fontsource/geist-sans/400.css';
import '@fontsource/geist-sans/500.css';
import '@fontsource/geist-sans/600.css';
import '@fontsource/geist-sans/700.css';
import '@fontsource/geist-mono/400.css';
import '@fontsource/geist-mono/500.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import { theme } from './theme/theme';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found in index.html');
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Default 5-min staleTime so navigating between pages reuses cached data
      // instead of refetching (#153) — search data only changes at the scrape
      // cadence, and the API now sends matching Cache-Control. Per-query
      // overrides (e.g. 1h on taxonomy/inventory) live next to each useQuery.
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

createRoot(container).render(
  <StrictMode>
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </ThemeProvider>
    </HelmetProvider>
  </StrictMode>
);
